import {
  Box,
  Center,
  Heading,
  HStack,
  Icon,
  IconButton,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from '@chakra-ui/react'
import { ChevronRight, LucideIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Buttons } from '@/components/shared/buttons'

type TaskContent = {
  id: string | number
  title: string
  description: string
  icon: LucideIcon
  url: string
}

interface Props {
  data: {
    contracts: Array<TaskContent>
    calls: Array<TaskContent>
    orders: Array<TaskContent>
  }
  isFetching?: boolean
  refetch?: () => void
}

const TaskDisplayList = ({ data }: { data: Array<TaskContent> }) => {
  return (
    <Box maxH={300} overflowY="auto" pr={2}>
      {data.map((ea) => {
        return (
          <HStack
            key={ea.id}
            gap={4}
            borderBottom="1px solid"
            borderBottomColor="gray.200"
            py={4}
          >
            <Icon as={ea.icon} boxSize={6} strokeWidth={1} />
            <Box flex={1}>
              <Text>{ea.title}</Text>
              <Text fontSize="xs" color="gray.400">
                {ea.description}
              </Text>
            </Box>
            <Link to={ea.url}>
              <IconButton
                aria-label="Redirect"
                icon={<Icon as={ChevronRight} />}
                colorScheme="primary"
              />
            </Link>
          </HStack>
        )
      })}
      {data.length === 0 && (
        <Box color="gray.400" fontSize="sm">
          Nenhuma tarefa pendente
        </Box>
      )}
    </Box>
  )
}

const TabHeader = ({ label, count }: { label: string; count: number }) => {
  return (
    <Tab>
      <HStack>
        <Text>{label}</Text>
        <Center
          bg="gray.100"
          w={6}
          h={6}
          fontSize="sm"
          borderRadius="sm"
          fontWeight="normal"
          px={2}
        >
          {count}
        </Center>
      </HStack>
    </Tab>
  )
}

export const TodoList = ({ data, isFetching, refetch }: Props) => {
  return (
    <Box>
      <HStack mb={4}>
        <Heading fontSize="lg" fontWeight="normal">
          Minhas tarefas
        </Heading>
        <Buttons.Refresh isLoading={isFetching} onClick={refetch} />
      </HStack>

      <Tabs colorScheme="primary">
        <TabList>
          <TabHeader label="Chamados" count={data.calls.length} />
          <TabHeader label="Ordens" count={data.orders.length} />
          <TabHeader label="Contratos" count={data.contracts.length} />
        </TabList>
        <TabPanels>
          <TabPanel>
            <TaskDisplayList data={data.calls} />
          </TabPanel>
          <TabPanel>
            <TaskDisplayList data={data.orders} />
          </TabPanel>
          <TabPanel>
            <TaskDisplayList data={data.contracts} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
